import { pwaPath } from "./path";

import type { IExtendedRouteObject } from "@routes/types";
import { useUIStore } from "@/stores/uiStore";

export const pwaRoutes: IExtendedRouteObject[] = [
  {
    permissions: "all",
    route: {
      path: pwaPath.home(),
      lazy: () => import("@/pages/commonPages/pwa/page"),
      loader: ({ request }) => {
        useUIStore.getState().setPage(request, "pwa", null, "index");
        return null;
      },
    },
  },
];
